import React, { useCallback } from 'react'
import VideoDuration from 'Components/video/video-duration'
import VideoSize from 'Components/video/video-size'
import AuthorAvatar from 'Components/author/author-avatar'
import VideoStats from 'Components/video/video-stats'
import formatDuration from 'lib/format-duration'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image, ImageStyles, ImageZoom } from 'Components/view-image'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import TimeDuration from 'Components/new/time-duration'

interface IProps {
  order?: number
  category: string
  className?: string
  uniqueIdStr: string
  title: string
  coverUrl: string
  duration: number
  avatar: string
  name: string
  videoWatchCount: number
  publishTime: number
  userId: string
  [key: string]: any
}

const Item: React.FC<IProps> = ({
  order,
  category,
  uniqueIdStr,
  title,
  coverUrl,
  duration,
  avatar,
  name,
  className,
  userVerified,
  userId,
  videoWatchCount,
  publishTime,
  ...props
}) => {
  return (
    <div
      className={`feed-item tw-h-full ${className ? className : ''}`}
      {...props}
    >
      <div className="image-wrap tw-w-90 xl:tw-w-108 tw-h-60 xl:tw-h-72 tw-relative">
        <a
          data-log-click={JSON.stringify({
            event: 'clk_event',
            params: {
              event_id: 'related_group_module_item_group',
            },
          })}
          className="image-link "
          href={`/${duration ? 'video' : 'article'}/${uniqueIdStr}`}
          target="_self"
        >
          <Image
            alt={title}
            src={coverUrl}
            width={133}
            height={72}
            lazy={true}
            layout={'fill'}
            className="tw-rounded-2 g-load-img-wrap"
            hoverTransition
          />
        </a>
        {duration && <TimeDuration duration={duration} />}
      </div>
      <div className="info-right tw-ml-10 ">
        <a
          data-log-click={JSON.stringify({
            event: 'clk_event',
            params: {
              event_id: 'related_group_module_item_group',
            },
          })}
          target="_self"
          href={`/${duration ? 'video' : 'article'}/${uniqueIdStr}`}
          title={title}
          className="title line-2 g-active-link-text tw-text-14 xl:tw-text-16 tw-font-semibold"
        >
          {title}
        </a>
        <div className="info-bottom">
          <a
            data-log-click={JSON.stringify({
              event: 'clk_event',
              params: {
                event_id: 'related_group_module_item_user',
                to_user_id: `${userId}`,
              },
            })}
            target="_blank"
            href={`/user/${userId}`}
            className="author g-active-link-text line-1 md:tw-inline-block tw-hidden tw-mt-2"
          >
            {name}
          </a>
          <span className="play-count line-1 tw-mt-2">
            {formatNumber(videoWatchCount)}次{duration ? '播放' : '阅读'}
          </span>
        </div>
      </div>
      <style jsx>
        {`
          .feed-item {
            overflow: hidden;
            position: relative;
            display: flex;
            padding: 14px 0px;
            border-bottom: 1px #f2f4fa solid;
            height: 101px;
          }
          .feed-item:last-child {
            margin-right: 0;
          }
          .image-wrap {
            position: relative;
          }
          .image-link {
            border-radius: 2px;
            display: block;
            line-height: 0;
          }

          .info-right {
            flex: 1;
            display: block;
            overflow: hidden;
          }
          .info-bottom {
            display: flex;
            color: #606370;
          }
          .title {
            color: #1f2129;
          }
          .author {
            flex: 1;
            font-size: 14px;
            color: #979aa8;
          }
          .play-count {
            font-size: 14px;
            color: #979aa8;
          }
          :global(.home-feed-card .feed-item .common-image-zoom img) {
            object-fit: cover;
          }
        `}
      </style>
    </div>
  )
}

export default Item
